import React from "react";
import * as dc from "dc";
import * as d3 from "d3";
import reductio from "reductio";
import { ChartTemplate } from "../chartTemplate";

const soilFertilityFuncChart = (divRef, ndx) => {
  // remove empty  bins since some rows contain null
  function remove_empty_bins(source_group) {
    return {
      all: function () {
        return source_group.all().filter(function (d) {
          //return Math.abs(d.value) > 0.00001; // if using floating-point numbers
            return d.key == "soil fertility"; // if integers only
        });
      },
    };
  }
    const dimension = ndx.dimension((d) => d.topographical_conditions);
    // reduce  the topographical conditions by sum of individual  biophysical parameters
  var grp = dimension.group().reduceSum(function (d) {
    return d.bio_parameters_values;
  });
    

    // custom reduce function
    const anualPrepgroup = dimension.group().reduce(
        /* callback for when data is added to the current filter results */
        function (p, v) {
            ++p.count;
            p.tot += v.bio_parameters_values;
            p.avg += p.count ? p.tot / 47 : 0;
          /*  p.actual = v.bio_parameters_values*/
            return p;
        },
        /* callback for when data is removed from the current filter results */
        function (p, v) {
            --p.count;
            p.tot -= v.bio_parameters_values;
            p.avg -= p.count ? p.tot / 47 : 0; // hard code number of counties due to dublicates in data
           /* p.actual = v.bio_parameters_values*/
            return p;
        },
        /* initialize p */
        function () {
            return { count: 0, tot: 0, avg:0};
        }
    );
      
    // only return soil fertility from the dimension group
    const seoil_fertility_bin = remove_empty_bins(anualPrepgroup)

    const totalsum = seoil_fertility_bin.all()
  // get the totals of all  the rows
    const sum_bins = totalsum[0].value["tot"]
    // define a dc chart object 
    const valueChart = dc.numberDisplay(divRef);


    valueChart
        .dimension(dimension)
        .group(remove_empty_bins(anualPrepgroup))

        .transitionDuration(0)

        .formatNumber(d3.format(".2f"))

        .on("pretransition  ", function (chart) {

            chart.valueAccessor((d) => {

              
                  let a = d.value["tot"] // current filter total 
                  let c_count = d.value["count"] // current records in the bin
                  let b = sum_bins // sum of all the records 
             
                  if (a < b && c_count == 1) { // return the current record if the it's less than total sum
                      return a
                  } else if (a < b && c_count > 1) {
                      return a / c_count // return average of the current filter
                  } else if (a == b) {
                      
                      return b/47 // return the average of all the records
                 
                  }
            });


        })

        .valueAccessor((d) => {

            
            return d.value["tot"] / 47; // default values at national

        })


    return valueChart;

};


export const SoilFertilityChart = (props) => (
  <ChartTemplate chartFunction={soilFertilityFuncChart} />
);
